import { Component, Input } from "@angular/core";
import {
  VAIconRegistryService,
  search,
  exclamationTriangle,
} from "@va/core-library/icons";
import { DEFAULT_RANGE_PERIOD_FILTER_DATA } from "@va/core-library/period-filter";
import { DUPLICATE_NAME_ERROR_MSG } from "../constants";

@Component({
  selector: "app-create-new-comparative-analysis-wizard",
  templateUrl: "./create-new-comparative-analysis-wizard.component.html",
  styleUrls: ["./create-new-comparative-analysis-wizard.component.scss"],
})
export class CreateNewComparativeAnalysisWizardComponent {
  @Input() currentIndex = 0;
  @Input() addRowTableData: Array<any>;
  @Input() addColTableData: Array<any>;
  @Input() marketItemsData: Array<any>;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies;
  @Input() industryData;
  @Input() watchlistData;
  @Input() marketGeoData;
  @Input() maxTickers;
  @Input() isCreateNewModalIndustryMenu: boolean;
  @Input() menuList;
  @Input() showSaveWatchList: boolean;
  @Input() isTickerTypeBg = false;
  @Input() periodsWithAvailableDataForPopup;

  mpt: number = null;
  max: number;
  tickers = [];
  stdLineItems: Array<any> = [];
  createLiDataFetch = false;
  createSource = "";
  tabName = "";
  yearTypeData = {
    ...DEFAULT_RANGE_PERIOD_FILTER_DATA,
    from_to: {
      selected_from: new Date().getFullYear() - 2,
      selected_to: new Date().getFullYear() + 4,
    },
  };
  displayAdditionalColumns = false;
  duplicateErrorMsg = DUPLICATE_NAME_ERROR_MSG;
  isDuplicateName: boolean = false;
  periodMinMax = { min: -10, max: 9 };

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([search, exclamationTriangle]);
  }
  moveToNextStep() {
    if (this.currentIndex < 3) {
      this.currentIndex++;
    }
  }

  moveToPreviousStep() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  onUpdateComp(compData) {
    this.addColTableData = compData;
  }

  onTickerUpdate(tickerData) {
    this.addRowTableData = tickerData;
  }

  onMptUpdate(mpt) {
    this.mpt = mpt;
  }

  handlePeriodApply(data) {
    this.yearTypeData = data.updatedPeriodData;
  }
}
